var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style['news']},[(_vm.isMobile)?_c('NewsPageMobile'):_c('NewsPageWeb')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }